// @flow @jsx h
import { h, Component } from 'preact'
import { SerumResponsivePicture } from '@nrk/dh-feature-components'
import { bem } from '@nrk/dh-utils'
import { connect } from '../../lib/provider'

/* styles */
import styles from './App.css'

function toArray (str: string) {
  return (str || '').split(',')
    .map(str => str.trim())
}

type Props = {
  sendGaEvent: (Object) => void,
  title: string,
  lead: string,
  link: string,
  images: string,
  theme: string
}

class _App extends Component<Props> {
  render () {
    const { link, title, lead, images, theme } = this.props
    const imageList = toArray(images)
    const themeClass = () => {
      switch (theme) {
        case 'theme-orderud':
          return styles.themeOrderud
        default:
          return 'themeDefault'
      }
    }
    return (
      <div class={`${styles.app} ${themeClass()}`}>
        <div class={`${styles.plugWrapper} ${styles.plugFullWidth} nrk-aspect nrk-aspect--16x9`}>
          <a href={link} class={styles.plugContent}>
            <h2 class={styles.plugTitle}>{title}</h2>
            <div class={styles.plugLead}>
              <p>
                {lead}
              </p>
              <div class={styles.plugButton}>
                <svg style='width: 1.5em; height: 1.5em' aria-hidden='true'>
                  <use xlinkHref='#nrk-chevron-right' />
                </svg>
              </div>
            </div>
          </a>

          {images && (
            <div className={bem(styles.plug__imageContainer, imageList.length + 'images')} aria-hidden='true'>
              {
                imageList.map(imageId => {
                  return <SerumResponsivePicture key={imageId} id={imageId} />
                })
              }
            </div>
          )}
          <div class={styles.plugOverlay} />
        </div>
      </div>
    )
  }
}

const connector = connect()
export const App = connector(_App)



// WEBPACK FOOTER //
// ./src/v1/components/App.js